<template>
    <transition name="layout-fade">
        <Loader v-if="loading"/>
        <v-layout wrap class="layout-add--max_width" v-else>
            <Navigation/>
            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>
        </v-layout>
    </transition>
</template>

<script>
    import Navigation from './Navigation'
    import Push from '../../../api/push'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'pushLayout',
        components: {
            Navigation,
            Loader
        },
        data: () => ({
            loading: false
        }),
        mounted () {
            this.loading = true

            Push
                .getAll()
                .then(response => this.$store.commit('storePushes', response.data.data))
                .catch(error => new Error(error))
                .finally(() => this.loading = false)
        }
    }
</script>
